module.exports = __webpack_public_path__ + "media/images/vip-events-and-experiences-477f7272b7982b227ac1acc6546c19e9.jpg";